"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCardUnassigned = exports.UserCard = void 0;
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const theme_1 = require("../../components/theme");
const theme_2 = require("../../components/theme");
const user_icon_1 = require("../../components/user/user.icon");
const i18n_1 = require("../../i18n");
const render_service_1 = require("../../services/render.service");
const userDisplayName_1 = require("../../util/userDisplayName");
const CSS = {
    container: 'c-UserCard',
    chip: 'c-UserCard--Chip',
    readonly: 'c-UserCard--ReadOnly',
    content: 'c-UserCard__Content',
    icon: 'c-UserCard__Icon',
    name: 'c-UserCard__Name',
    username: 'c-UserCard__Username'
};
const Style = {
    [CSS.container]: {
        display: 'flex',
        'align-items': 'center',
        cursor: 'pointer',
        'text-align': 'left',
        'line-height': theme_2.DefaultTheme.space(4)
    },
    [CSS.chip]: {
        'background-color': theme_2.DefaultTheme.background.lightGrey,
        'border-radius': theme_2.DefaultTheme.space(6)
    },
    [CSS.readonly]: {
        cursor: 'default'
    },
    [CSS.icon]: {
        'margin-right': theme_2.DefaultTheme.space(1)
    },
    [CSS.name]: {
        'margin-right': theme_2.DefaultTheme.space(3)
    },
    [CSS.username]: {
        color: theme_2.DefaultTheme.font.color.supporting
    }
};
(0, theme_1.addStyles)(Style);
exports.UserCard = {
    view(user, content, ctx = {}) {
        const displayName = (0, userDisplayName_1.userDisplayName)(user);
        return (0, render_service_1.m)('div', { className: `${CSS.container} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(user)),
            (0, render_service_1.m)('div', { className: CSS.content }, [
                (0, render_service_1.m)('div', { className: CSS.name }, [
                    (0, render_service_1.m)('span', content != null ? content : displayName),
                    ctx.me ? (0, render_service_1.m)('span', ` (${(0, i18n_1.Translate)(i18n_1.T.ME)})`) : null
                ]),
                displayName !== user.username ? (0, render_service_1.m)('div', { className: CSS.username }, user.username) : null
            ])
        ]);
    },
    viewChip(user, ctx = {}) {
        return (0, render_service_1.m)('div', { className: `${CSS.container} ${CSS.chip} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(user)),
            (0, render_service_1.m)('div', { className: CSS.name }, (0, userDisplayName_1.userDisplayName)(user)),
            ctx.readonly ? null : image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, { onclick: ctx.cancel })
        ]);
    }
};
exports.UserCardUnassigned = {
    view(content, ctx = {}) {
        return (0, render_service_1.m)('div', { className: `${CSS.container} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(null)),
            (0, render_service_1.m)('div', { className: CSS.content }, [
                (0, render_service_1.m)('div', { className: CSS.name }, content)
            ])
        ]);
    },
    viewChip(ctx = {}) {
        return (0, render_service_1.m)('div', { className: `${CSS.container} ${CSS.chip} ${ctx.readonly ? CSS.readonly : ''}`, onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(null)),
            (0, render_service_1.m)('div', { className: CSS.name }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UNASSIGNED)),
            ctx.readonly ? null : image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, { onclick: ctx.cancel })
        ]);
    }
};
//# sourceMappingURL=user.card.js.map